import React from "react";
import Container from "./Container";
import { COMPANY_INFO, IMAGES, NAV_LINKS } from "../constants";

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 py-14 pb-24 text-zinc-200 md:pb-14">
      <Container>
        <div className="animate-fade-in-up grid gap-10 md:grid-cols-3">
          <div>
            <img
              src={IMAGES.logo}
              alt="Logo AsiViajo"
              className="h-24 w-auto sm:h-28 md:h-32"
            />
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.1em] text-zinc-300">
              Navegación
            </h3>
            <ul className="mt-4 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <a href={link.href} className="text-zinc-400 transition hover:text-white">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.1em] text-zinc-300">
              Contacto
            </h3>
            <ul className="mt-4 space-y-3 text-zinc-400">
              <li>{COMPANY_INFO.email}</li>
              <li>{COMPANY_INFO.phone}</li>
              <li>{COMPANY_INFO.address}</li>
            </ul>
          </div>
        </div>

        <p className="mt-10 border-t border-zinc-800 pt-6 text-sm text-zinc-500">
          {year} {COMPANY_INFO.name}. Todos los derechos reservados.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
